import 'babel-polyfill'
import 'es6-promise/auto'
require('bootstrap');

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register("/service-worker.js");
}

window._ = require('lodash');

window.moment = require('moment');

window.datalist = require('datalist-polyfill');

require('jquery.scrollto');

window.moment.locale('en-gb')

window.moment.fn.toString = function () { return this.format('YYYY-MM-DD HH:mm:ss'); };
window.moment.fn.toJSON = function () { return this.format('YYYY-MM-DD HH:mm:ss'); };


/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: window.env.MIX_PUSHER_KEY,
    cluster: 'eu',
    encrypted: true,
    authEndpoint: '/broadcasting/auth',
    auth: {
        headers: {
            'X-CSRF-TOKEN': token.content,
        },
    },
});

window.AuthService = require('./services/AuthService').default;
window.AuthService.init();

window.axios.interceptors.response.use((response) => { // intercept the global error
    return response
}, function (error) {
    if (error.response && error.response.status === 401) {
        // We don't want to do anything globally if login fails
        if (error.config.url === '/api/auth/login' || error.config.url === '/api/auth/logout' || error.config.url === '/api/auth/me' || error.config.url === '/api/auth/refresh') {
            return Promise.reject(error);
        }
        window.AuthService.logout();
        const redirect = window.location;
        window.location.replace(`/#/login?redirect=${redirect}`);
        return;
    }
    // We canot handle this error globally...
    return Promise.reject(error);
})


// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js